import * as React from 'react';
import { useTooltipController } from './useTooltipController';
import { CustomTooltip } from '../CustomTooltip';

/**
 * Компонент подсказки в виде всплывающего текста
 *
 * @export
 * @param {ITooltipProps} props
 * @returns
 */
export function TooltipDesktop(props) {
  var theme = props.theme,
    placement = props.placement,
    title = props.title,
    portal = props.portal,
    arrow = props.arrow;
  var _useTooltipController = useTooltipController(props),
    childrenProps = _useTooltipController.childrenProps,
    tooltipProps = _useTooltipController.tooltipProps;
  var open = tooltipProps.open,
    anchorRef = tooltipProps.anchorRef,
    onMouseEnter = tooltipProps.onMouseEnter,
    onMouseLeave = tooltipProps.onMouseLeave;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(props.children, childrenProps), /*#__PURE__*/React.createElement(CustomTooltip, {
    open: open,
    anchorRef: anchorRef,
    content: title,
    placement: placement,
    theme: theme,
    portal: portal,
    arrow: arrow,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }));
}
TooltipDesktop.defaultProps = {
  theme: 'black'
};